import { styled } from '@mui/material/styles';
import { useSwimlaneRootProps } from '@/components/ui/swimlane/context';
import {
  AXIS_HEIGHT,
  COLUMN_HEADER_HEIGHT,
  GRID_GAP,
  GROUP_COL_INNER_GAP,
  ROW_HEADER_WIDTH,
} from '../constants';

// These styles allow the corner to mask the CSS grid gap
// This prevents the Card on hover shadow from bleeding past headers
const StyledDiv = styled('div', {
  shouldForwardProp: (prop) =>
    prop !== 'isHeadersSticky' &&
    prop !== 'backgroundColor' &&
    prop !== 'isPngPublicationTemplate' &&
    prop !== 'isPdfExportTemplate',
})<{
  isHeadersSticky: boolean;
  backgroundColor: string;
  isPngPublicationTemplate?: boolean;
  isPdfExportTemplate?: boolean;
}>(({ isHeadersSticky, backgroundColor, isPngPublicationTemplate, isPdfExportTemplate }) => ({
  backgroundColor,
  position:
    isHeadersSticky && !isPngPublicationTemplate && !isPdfExportTemplate ? 'sticky' : 'relative',
  gridArea: 'erase',
  zIndex: '11',
  left: `-${GRID_GAP.label}`,
  top: 0,
  boxSizing: 'content-box',
}));

export function TopLeftCorner() {
  const {
    rowHeaderOrientation,
    rowHeadersWidth,
    rowHeaders,
    isHeadersSticky,
    backgroundColor,
    columnAxisLabelText,
    rowAxisLabelText,
    isAddRowHeaderButtonVisible,
    isPngPublicationTemplate,
    isPdfExportTemplate,
  } = useSwimlaneRootProps();

  const hasRowHeaders = rowHeaders.length > 0;
  const hasAxisLabelColumn = typeof columnAxisLabelText === 'string';
  const hasAxisLabelRow = typeof rowAxisLabelText === 'string';

  const hasGroupHeaders = rowHeaders.some((h) => 'isGroupHeader' in h && h.isGroupHeader === true);
  const groupColumnExtra = hasGroupHeaders
    ? ROW_HEADER_WIDTH.vertical.value + GROUP_COL_INNER_GAP.value
    : 0;

  const height = hasAxisLabelColumn
    ? COLUMN_HEADER_HEIGHT.value + GRID_GAP.value + AXIS_HEIGHT.value
    : COLUMN_HEADER_HEIGHT.value;
  const axisWidth = hasAxisLabelRow ? ROW_HEADER_WIDTH.vertical.value + GRID_GAP.value : 0;
  const baseHeaderWidth = hasRowHeaders
    ? rowHeaderOrientation === 'vertical'
      ? ROW_HEADER_WIDTH.vertical.value
      : rowHeadersWidth
    : isAddRowHeaderButtonVisible
      ? ROW_HEADER_WIDTH.vertical.value
      : 0;
  const totalWidth =
    baseHeaderWidth > 0 || axisWidth > 0
      ? `${groupColumnExtra + baseHeaderWidth + axisWidth + GRID_GAP.value}px`
      : `${axisWidth + GRID_GAP.value}px`;

  return (
    <StyledDiv
      backgroundColor={backgroundColor}
      isHeadersSticky={!!isHeadersSticky}
      isPngPublicationTemplate={isPngPublicationTemplate}
      isPdfExportTemplate={isPdfExportTemplate}
      style={{
        width: totalWidth,
        height,
      }}
    />
  );
}
